import type {HTMLAttributes, ReactNode} from 'react'
import {cn} from '@/lib/utils'
import {useIsEmbedded} from './EmbeddedContext'

interface SectionContainerProps extends HTMLAttributes<HTMLElement> {
    children: ReactNode
    embedded?: boolean
}

export function SectionContainer({children, embedded, className, ...rest}: SectionContainerProps) {
    const contextEmbedded = useIsEmbedded()
    const isEmbedded = embedded ?? contextEmbedded
    if (isEmbedded) {
        return <div className={className} {...rest}>{children}</div>
    }
    return (
        <main
            id="main-content"
            className={cn('page-container', className)}
            {...rest}
        >
            {children}
        </main>
    )
}
